export const STATUS = {
  ALL: {
    display: 'View All',
  },
  AWAITING_PAYMENT: {
    display: 'Awaiting Payment',
    class: 'badge-awaiting-payment',
  },
  CANCELLED: {
    display: 'Cancelled',
    class: 'badge-cancelled',
  },
  FLOATING: {
    display: 'Floating',
    class: 'badge-pending',
  },
  PARTIALLY_REFUNDED: {
    display: 'Partially refunded',
    class: 'badge-partially-refunded',
  },
  REFUNDED: {
    display: 'Refunded',
    class: 'badge-refunded',
  },
  PAID: {
    display: 'Paid',
    class: 'badge-paid',
  },
  PAYMENT_DUE: {
    display: 'Payment due',
    class: 'badge-payment_due',
  },
  'PENDING PAYMENT': {
    display: 'Pending Payment',
    class: 'badge-pending_payment',
  },
  NOT_PAID: {
    display: 'Not paid',
    class: 'badge-not-paid',
  },
  PENDING: {
    display: 'Processing',
    class: 'badge-pending',
  },
  VOIDED: {
    display: 'Voided',
    class: 'badge-voided',
  },
  POSTED: {
    display: 'Posted',
    class: 'badge-posted',
  },
  'CANCEL COD': {
    display: 'COD Cancelled',
    class: 'badge-cancelled',
  },
  'SUBSCRIPTION CANCELLED': {
    display: 'Subscription Cancelled',
    class: 'badge-cancelled',
  },
  DELIVERING: {
    display: 'Delivering',
    class: 'badge-paid',
  },
  COMPLETED: {
    display: 'Completed',
    class: 'badge-paid',
  },
  PROCESSING: {
    display: 'Processing',
    class: 'badge-paid',
  },
  RETURNED: {
    display: 'Returned',
    class: 'badge-cancelled',
  },
  'WAITING APPROVAL': {
    display: 'Waiting Approval',
    class: 'badge-pending_payment',
  },
  'COD APPROVAL': {
    display: 'COD Approval',
    class: 'badge-approval',
  },
  'SELF COLLECT': {
    display: 'Self Collect Approval',
    class: 'badge-approval',
  },
  'CANCEL SELF COLLECT': {
    display: 'Cancel Self Collect',
    class: 'badge-cancelled',
  },
  'PENDING CONFIRMATION': {
    display: 'Pending Confirmation',
    class: 'badge-pending_payment',
  },
  'SUBSCRIPTION INITIATED': {
    display: 'Subscription Initiated',
    class: 'badge-awaiting-payment',
  },
  'PENDING CANCEL SUBSCRIPTION': {
    display: 'Pending Cancel Subscription',
    class: 'badge-cancelled',
  },
};

// Badge colours for the labels the API sends as order_status_label /
// payment_status_label (partners-middleware OrderStatusLabel).
export const ORDER_STATUS_BADGE = {
  'Waiting Approval': 'badge-approval',
  'Pending': 'badge-pending',
  'Processing': 'badge-paid',
  'Delivering': 'badge-paid',
  'Completed': 'badge-paid',
  'Returned': 'badge-cancelled',
  'Cancelled': 'badge-cancelled',
  'Awaiting Payment': 'badge-awaiting-payment',
  'Awaiting Fulfilment': 'badge-pending',
  'Pending Confirmation': 'badge-pending_payment',
  'On Hold': 'badge-pending',
  'Subscription Initiated': 'badge-awaiting-payment',
  'Pending Cancel Subscription': 'badge-cancelled',
  'Subscription Cancelled': 'badge-cancelled',
};

export const PAYMENT_STATUS_BADGE = {
  'Paid': 'badge-paid',
  'Cash Collected': 'badge-paid',
  'Unpaid': 'badge-pending_payment',
  'Payment Pending': 'badge-pending_payment',
  'Pay on Delivery': 'badge-approval',
  'Pay at Collection': 'badge-approval',
  'Not Charged': 'badge-not-paid',
  'On Hold': 'badge-pending',
  'Subscription Initiated': 'badge-awaiting-payment',
  'Pending Cancel Subscription': 'badge-cancelled',
  'Subscription Cancelled': 'badge-cancelled',
};

// Hover text for the order / payment badges.
export const ORDER_STATUS_HINT = {
  'Waiting Approval': 'Waiting for the order to be approved before it is sent for fulfilment.',
  'Pending': 'Received by 5s; fulfilment has not started yet.',
  'Processing': 'The warehouse is picking and packing the order.',
  'Delivering': 'Handed to the courier and on the way to the customer.',
  'Completed': 'Delivered to the customer.',
  'Returned': 'Delivery failed or the parcel was returned to the warehouse.',
  'Cancelled': 'The order was cancelled and will not be fulfilled.',
  'Awaiting Payment': 'Waiting for the customer to complete payment.',
  'Awaiting Fulfilment': 'Paid, but not yet received by 5s.',
  'Pending Confirmation': 'Waiting for manual confirmation, such as a bank transfer slip.',
  'On Hold': 'Held by 5s for review (e.g. address or stock issue). Contact 5s support to resolve it.',
  'Subscription Initiated': 'Subscription set up; the first order has not started yet.',
  'Pending Cancel Subscription': 'Subscription cancellation is being processed.',
  'Subscription Cancelled': 'The subscription was cancelled; no further renewals.',
};

export const PAYMENT_STATUS_HINT = {
  'Paid': 'The online payment was successful.',
  'Unpaid': 'No payment has been received yet.',
  'Payment Pending': 'The payment was started but not completed.',
  'Pay on Delivery': 'The customer pays the courier in cash on delivery.',
  'Pay at Collection': 'The customer pays when collecting the order.',
  'Cash Collected': 'The order was delivered and the cash was collected.',
  'Not Charged': 'The order was cancelled or returned; the customer was not charged.',
  'On Hold': 'The payment is on hold for review.',
  'Subscription Initiated': 'The card is saved for subscription billing.',
  'Pending Cancel Subscription': 'Subscription cancellation is being processed.',
  'Subscription Cancelled': 'No further subscription charges will be made.',
};

export const ORDER_TYPE = {
  DEFAULT: {
    display: 'Default',
    class: 'badge-primary',
  },
  MEMBERSHIP: {
    display: 'Membership',
    class: 'badge-info',
  },
  OPEN_API: {
    display: 'Open API',
    class: 'badge-success',
  },
  FIV5S: {
    display: 'Fiv5s',
    class: 'badge-secondary',
  },
};

export const PAYMENT = {
  ALL: { display: 'View All' },
  COD: { display: 'Cash on delivery' },
  NON_COD: { display: 'Online Payment' },
  SELF_COLLECT: { display: 'Self Collect' },
  INSTALLMENT: { display: 'Installment'},
  SUBSCRIPTION: { display: 'Subscription'}
};

export const SUBSCRIPTIONSTATUS ={
  ALL: { display: 'View All'},
  ACTIVE: { display: 'Active', class: 'badge-paid' },
  PENDING: { display: 'Pending', class: 'badge-pending' },
  VOID: { display: 'Void', class: 'badge-voided' },
  ENDED: { display: 'Ended', class: 'badge-paid' },
  TERMINATED: { display: 'Terminated', class: 'badge-cancelled' },
  COMPLETED: { display: 'Completed', class: 'badge-paid' },
  CANCELLED: { display: 'Cancelled', class: 'badge-cancelled' },
  FLOATING: { display: 'Floating', class: 'badge-pending' },
  'PENDING PAYMENT': { display: 'Pending Payment', class: 'badge-pending_payment' },
} 

export const PLATFORM = {
  ALL: { display: 'View All' },
  DEFAULT: { display: 'Default' },
  OPENAPI: { display: 'Open Api' },
  MEMBERSHIP: { display: 'Membership' },
  FIV5S: { display: 'Fiv5s' },
};

export const SOURCE = [
  { display: 'View All', value: 'ALL', id: 0 },
  { display: 'Normal', value: 'normal', id: 1 },
  { display: 'Express Checkout', value: 'express_checkout', id: 2 },
  { display: 'Aemis', value: 'aemis', id: 3 },
  { display: 'Subscription', value: 'subscription', id: 4 },
  { display: 'Pre Order', value: 'pre_order', id: 5 },
  { display: 'Repurchase', value: 'repurchase', id: 7 },
];

export const CART = [
  { display: 'View All', value: 'ALL', id: -1 },
  { display: 'Pending', value: 'pending', id: 0 },
  // { display: 'Completed', value: 'completed', id: 1 },
  { display: 'Resolved', value: 'resolved', id: 2 },
  { display: 'Discarded', value: 'discarded', id: 8 },
  // { display: 'Deleted', value: 'deleted', id: 9 },
];

export const plugins = [
  'advlist autolink lists image preview anchor',
  'searchreplace code contextmenu visualblocks',
  'insertdatetime media table paste',
  'hr autoresize charmap link',
];

export const toolbarItems = [
  `
  bold italic underline | fontselect fontsizeselect | forecolor | formatselect
`,
];

export const fonts =
  'Roboto=roboto; Arial Black=arial black,avant garde; Courier New=courier new,courier; Lato Black=lato;';

export const DEALER_STATUS = {
  "0":{
    status: 'Active',
    class: 'badge-active',
  },
  "1": {
    status: 'Active',
    class: 'badge-active',
  },
  "5": {
    status: 'Banned',
    class: 'badge-suspended-banned',
  },
  "6": {
    status: 'Converted',
    class: 'badge-converted',
  },
  "8": {
    status: "Suspended",
    class: 'badge-suspended-banned',
  },"9": {
    status: 'Inactive',
    class: 'badge-inactive',
  }
};
